import { render, staticRenderFns } from "./Outofstocks.vue?vue&type=template&id=056abc44&"
import script from "./Outofstocks.vue?vue&type=script&lang=js&"
export * from "./Outofstocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports